import { render } from "./TheSymbolActions.vue?vue&type=template&id=bd63d8a4&scoped=true&ts=true"
import script from "./TheSymbolActions.vue?vue&type=script&lang=ts"
export * from "./TheSymbolActions.vue?vue&type=script&lang=ts"

import "./TheSymbolActions.vue?vue&type=style&index=0&id=bd63d8a4&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd63d8a4"]])

export default __exports__